import FormStruct from "@/components/Form/FormStruct/FormStruct";
import FormValidators from "@/components/Form/Validation/FormValidators";
import i18n from "@/i18n";
import BFInput from "@/modules/abstract-ui/forms/input/BFInput";
import { Field } from "react-final-form";
import { SkontoFields } from "../../../RAInterfaces";

const RAInvoicePaymentSkontoForm = (props: {
  onSubmit: (skontoField: SkontoFields) => void;
  onClose: () => void;
}) => {
  return (
    <FormStruct
      onAbort={props.onClose}
      onSubmit={(values) => {
        props.onSubmit(values);
        props.onClose();
      }}
      initialValues={{
        discountPercentage: 7,
        daysForPayment: 3,
      }}
      title={i18n.t(
        "ra:InvoiceForm.SkontoForm.Title",
        "Skonto-Rabatt hinzufügen"
      )}
      submitText={i18n.t(
        "ra:InvoiceForm.SkontoForm.Submit",
        "Skonto hinzufügen"
      )}
      render={(formProps) => (
        <>
          <div className={`ra-invoice-payment-plan-creation-form`}>
            <div className={`description`}>
              {i18n.t(
                "ra:InvoiceForm.SkontoForm.Description",
                "Geben Sie die Informationen für den Skonto-Rabatt ein."
              )}
            </div>

            <div className={`form`}>
              <div className={`__field`}>
                <Field
                  name={"discountPercentage"}
                  validate={FormValidators.compose(FormValidators.required())}
                >
                  {({ input, meta }) => (
                    <BFInput
                      type="number"
                      step={0.01}
                      label={i18n.t(
                        "ra:InvoiceForm.SkontoForm.discountPercentage",
                        "Skonto in Prozent"
                      )}
                      prefix={"%"}
                      {...input}
                      {...FormValidators.getValidation(meta)}
                    />
                  )}
                </Field>
              </div>
              <div className={`__field`}>
                <Field
                  name={"daysForPayment"}
                  validate={FormValidators.compose(FormValidators.required())}
                >
                  {({ input, meta }) => (
                    <BFInput
                      type="number"
                      step={1}
                      label={i18n.t(
                        "ra:InvoiceForm.SkontoForm.daysForPayment",
                        "Zahlungsziel in Tagen"
                      )}
                      prefix={i18n.t("Global.Labels.days", "Tage")}
                      {...input}
                      {...FormValidators.getValidation(meta)}
                    />
                  )}
                </Field>
              </div>
            </div>
          </div>
        </>
      )}
    />
  );
};
export default RAInvoicePaymentSkontoForm;
